/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Media_TitleInputs */

const en_ocr_media_title = /** @type {(inputs: Ocr_Media_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR Media - Extract Burnt-In Text`)
};

const fr_ocr_media_title = /** @type {(inputs: Ocr_Media_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supports OCR - Extraction de texte incrusté`)
};

const de_ocr_media_title = /** @type {(inputs: Ocr_Media_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR Media – Eingebrannten Text extrahieren`)
};

const it_ocr_media_title = /** @type {(inputs: Ocr_Media_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR Media - Estrazione del testo incorporato`)
};

const ru_ocr_media_title = /** @type {(inputs: Ocr_Media_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR Media - Извлечение встроенного текста`)
};

const es_ocr_media_title = /** @type {(inputs: Ocr_Media_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medios OCR - Extraer texto incrustado`)
};

const zh_cn2_ocr_media_title = /** @type {(inputs: Ocr_Media_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR 介质 - 提取嵌入式文本`)
};

const ja_ocr_media_title = /** @type {(inputs: Ocr_Media_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCRメディア - 焼き付いたテキストの抽出`)
};

const hi_ocr_media_title = /** @type {(inputs: Ocr_Media_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओसीआर मीडिया - जले हुए पाठ को निकालें`)
};

const pt_pt2_ocr_media_title = /** @type {(inputs: Ocr_Media_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mídia OCR - Extrair texto gravado`)
};

/**
* | output |
* | --- |
* | "OCR Media - Extract Burnt-In Text" |
*
* @param {Ocr_Media_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_media_title = /** @type {((inputs?: Ocr_Media_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Media_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_media_title(inputs)
	if (locale === "de") return de_ocr_media_title(inputs)
	if (locale === "it") return it_ocr_media_title(inputs)
	if (locale === "ru") return ru_ocr_media_title(inputs)
	if (locale === "es") return es_ocr_media_title(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_media_title(inputs)
	if (locale === "ja") return ja_ocr_media_title(inputs)
	if (locale === "hi") return hi_ocr_media_title(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_media_title(inputs)
	return en_ocr_media_title(inputs)
});